<template>
  <b-card-code title="" no-body>
    <b-card-body>
      <b-row>
        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="Cari" label-for="basicInput">
            <b-form-input
              id="basicInput"
              placeholder="Search"
              v-model="search"
            />
          </b-form-group>
        </b-col>
        
        

        <b-col md="2" xl="2" class="mb-1">
          <!-- basic -->
          <b-form-group label="version" label-for="version">
            <b-form-input
              id="version"
              placeholder="1.0.0"
              v-model="version_search"
            />
          </b-form-group>
        </b-col>
       
        
        <b-col lg="3" md="3" class="mb-1">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-primary"
            class="mt-0 mt-md-2"
            @click="refreshPage()"
          >
            <feather-icon icon="SearchIcon" class="mr-25" />
            <span>Search</span>
          </b-button>
        </b-col>
        <b-col lg="2" md="2" class="mb-1">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="primary"
            class="mt-0 mt-md-2"
            @click="createPlatform()"
          >
            <feather-icon icon="EditIcon" class="mr-25" />
            <span>Input New</span>
          </b-button>
        </b-col>
      </b-row>

      
    </b-card-body>

    <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :items="items"
      :fields="fields"
      responsive
      class="mb-0"
      @row-selected="onRowSelected"
    >
      
    <template #cell(action)="data">
        <b-dropdown variant="link" no-caret toggle-class="p-0" right>
          <template #button-content>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </template>

          <b-dropdown-item @click="updatePlatform(data.item)">
            <feather-icon icon="EditIcon" size="16" />
            <span class="align-middle ml-50">Update</span>
          </b-dropdown-item>
         
          <b-dropdown-item @click="deletePlatform(data.item)">
            <feather-icon icon="TrashIcon" size="16" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        
        
        </b-dropdown>
      </template>
     
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <div></div>
      <!--pagination -->
      <div class="demo-inline-spacing pt-0">
        <b-pagination
          v-model="currentPage"
          hide-goto-end-buttons
          :total-rows="rows"
          :per-page="perPage"
        />
      </div>
    </b-card-body>
    

    <b-modal id="modal-create-platform" hide-footer no-close-on-backdrop>
      <template #modal-title> Create Platform </template>
      <div class="d-block text-center">
        <!-- <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p> -->
      </div>
     
          <!-- basic -->
          <b-col md="12" xl="12" class="mb-1">
            <b-form-group  label="Platform"  label-for="vue-select">
              <v-select
                id="vue-select"
                label="name"
                v-model="platform"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="platform_list"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Version" label-for="thevalue">
              <b-form-input
                id="thevalue"
                placeholder="version"
                v-model="value"
              />
            </b-form-group>
          </b-col>


      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitCreate()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
    <b-modal id="modal-update-platform" hide-footer no-close-on-backdrop>
      <template #modal-title> Update Platform </template>
      <div class="d-block text-center">
        <!-- <p>Apakah anda yakin? Jika ya silahkan input deskripsi.</p> -->
      </div>
     
          <!-- basic -->
        <b-col md="12" xl="12" class="mb-1">
          <b-form-group  label="Platform"  label-for="vue-select">
            <v-select
              id="vue-select"
              label="name"
              v-model="platform"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="platform_list"
            />
          </b-form-group>
        </b-col>
          <b-col md="12" xl="12" class="mb-1">
            <!-- basic -->
            <b-form-group label="Version" label-for="thevalue">
              <b-form-input
                id="thevalue"
                placeholder="version"
                v-model="value"
              />
            </b-form-group>
          </b-col>


      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitUpdate()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
    <b-modal id="modal-delete-platform" hide-footer>
      <template #modal-title> Update Platform </template>
      <div class="d-block text-center">
        <p>Apakah anda yakin?</p>
      </div>

      <b-button
        class="mt-3"
        variant="outline-primary"
        block
        @click="submitDelete()"
      >
        <feather-icon icon="SendIcon" /> Submit
      </b-button>
    </b-modal>
  </b-card-code>
  
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BButton, BFormGroup, BAvatar, BBadge, BCardBody, BPagination, BFormTextarea,
  BButtonToolbar, BButtonGroup, BDropdown, BDropdownItem, BFormInput, BRow, BCol, BModal
} from 'bootstrap-vue'
import API from '@/api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import router from '@/router'
import platform from '@/router/modules/platform'

export default {
  components: {
    BCardCode,
    BTable,
    BButton,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
    BPagination,
    BButtonToolbar,
    BButtonGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BModal,
    BFormTextarea
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      currentPage: 1,
      rows: 0,
      perPage: 20,
      modes: ['multi', 'single', 'range'],
      fields: ['id','platform', 'version', 'created_at', 'action'],
      /* eslint-disable global-require */
      items: [],
      /* eslint-disable global-require */
      search: null,
      version_search: null,
      detailPlatform: null,
      name: null,
      value: null,
      input: [
        platform => null,
        version=> null
      ],
      platform_list: [],
      platform:{id:1, nama_universitas:"Universitas Indonesia"}
      

    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    refreshPage() {
      if (this.currentPage == 1) {
        this.getPlatformVersion()
      }
      else {
        this.currentPage = 1
      }

    },
    async getPlatformVersion() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)

        const form = {
          limit: this.perPage,
          page: this.currentPage,
          platform: this.search,
          version: this.version_search,
          is_pagination:true
        }
        const data   = await this.encryptRequest(API.platform.platform_version(form))
        this.data_table = data.data.data
        this.items = data.data.data
        this.rows = data.data.total

        this.handleMsgSuccess('Berhasil tampilkan data log')
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    createPlatform() {
      this.$bvModal.show("modal-create-platform")
    },
    updatePlatform(item) {
      this.detailPlatform = item
      let obj = this.platform_list.find(o => o.value === item.platform);
      this.platform = obj
      this.value = item.version
      console.log(this.detailPlatform)
      this.$bvModal.show("modal-update-platform")

    },
    deletePlatform(item) {
      this.detailPlatform = item
      console.log(this.detailPlatform)
      this.$bvModal.show("modal-delete-platform")

    },
    async submitUpdate() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const form = {
          platform: this.platform.value, 
          version: this.value,
          id:this.detailPlatform.id
        }
        const data   = await this.encryptRequest(API.platform.update_platform_version(form))

        this.handleMsgSuccess('Berhasil update platform')
        this.$bvModal.hide("modal-update-platform")
        this.getPlatformVersion()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async submitDelete() {

      try {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
        const form = {
          id:this.detailPlatform.id
        }
        const data   = await this.encryptRequest(API.platform.delete_platform_version(form))

        this.handleMsgSuccess('Berhasil delete platform')
        this.$bvModal.hide("modal-delete-platform")
        this.getPlatformVersion()
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async submitCreate() {
      this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', true)
      try {
        
        var input = { 
            platform: this.platform.value, 
            version: this.value,
          }
        const {}  = await this.encryptRequest(API.platform.create_platform_version(input))
        this.handleMsgSuccess('Berhasil Create Platform')
        this.getPlatformVersion()
        this.$bvModal.hide("modal-create-platform")
      } catch (error) {
        console.log(error)
        this.handleMsgErrors(error, 'Terjadi kesalahan silahkan coba lagi!')
      }
      finally {
        this.$store.commit('SET_IS_LOADING_FOR_SUBMIT', false)
      }
    },
    async getPlatform() {
        try {
          const form = {
            get_all:true
          }
          const data   = await this.encryptRequest(API.platform.platform(form))
          this.platform_list = data.data
        } catch (error) {
          console.log(error)
        } finally {
         
        }
    },

  },
  mounted() {
    this.getPlatformVersion()
    this.getPlatform()
    
  },
  watch: {
    currentPage() {
      this.getPlatformVersion()
    },

  }
}
</script>

<style lang="scss">
.b-table-selectable {
  .feather {
    font-size: 1.3rem;
  }
}
</style>
